import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store/store';
import axios from './axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios,axios);
//iview
import ViewUI from 'view-design';
// import style
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);
// element 树结构
import 'element-ui/lib/theme-chalk/index.css';
import { Tree, Tabs, TabPane, DatePicker,Select,Option, Dialog, Input, Button, Table,
  TableColumn,Pagination,Loading } from 'element-ui';
Vue.use(Tree);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(DatePicker);
Vue.use(Select);
Vue.use(Option);
Vue.use(Dialog);
Vue.use(Input);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Loading);
// cookie
var VueCookies = require('vue-cookies');
var VueCookie = require('vue-cookie');
Vue.use(VueCookies);
Vue.use(VueCookie);
/*图片预览 这个插件好用的很 */
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
Vue.use(Viewer);
//高德地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: '8703b8bd142ac28cd3eada717b20a29d',
    v: '1.4.6',
    plugin: ['AMap.Scale', 'AMap.ToolBar','Geolocation'],
});
/*通用CSS*/
import './assets/css/style.css';
import './assets/css/main.less';
import './assets/iconfont/iconfont.css'
/*公共方法 (字母转文字)*/
import common from './components/common.js';
Vue.prototype.common=common;
import moment from 'moment'
Vue.prototype.$moment = moment
/*公共组件*/
import amapTF from './components/amapTF';
import imgviewer from './components/imgviewer';
import uploadTF from './components/uploadTF';
import uploadViewer from './components/uploadViewer';

/*页面组件*/
import HighSearch from './components/HighSearch';
import PlaceSelect from './components/PlaceSelect';


/*地图控件 longitude.sync latitude.sync  isEdit*/
Vue.component('amap-tf',amapTF);
/*附件预览控件*/
Vue.component('img-viewer',imgviewer);
/*上传控件 uploadList.sync */
Vue.component('upload-tf',uploadTF);
/*上传小图预览控件*/
Vue.component('upload-viewer',uploadViewer);
/* 高级搜索 */
Vue.component('high-search',HighSearch);
Vue.component('place-select',PlaceSelect);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
